import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const customStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const SelectFild = ({ Firstop, selectName, options, value, onChange, onBlur, isMulti = false, }) => {
    const [optionsList, setOptionsList] = useState([]);

    useEffect(() => {
        if (options && Array.isArray(options)) {
            if (selectName == 'sectorId' || selectName == 'subSectorids') {
                const updatedOptions = options.map(item => ({
                    value: item?.sector_id,
                    label: item?.sector_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'orgGroupId') {
                const updatedOptions = options.map(item => ({
                    value: item?.org_group_id,
                    label: item?.org_group_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'cpid') {
                const updatedOptions = options.map(item => ({
                    value: item?.channel_partner_id,
                    label: item?.org_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'pincodeId') {
                const updatedOptions = options.map(item => ({
                    value: item?.pincode_id,
                    label: item?.city_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'stage') {
                const updatedOptions = options.map(item => ({
                    value: item?.stage_id,
                    label: item?.stage_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'countryCode') {
                const updatedOptions = options.map(item => ({
                    value: item?.country_id,
                    label: item?.country_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'placeOfSupplyStateId') {
                const updatedOptions = options.map(item => ({
                    value: item?.state_id,
                    label: item?.state_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'orgId') {
                const updatedOptions = options.map(item => ({
                    value: item?.org_id,
                    label: item?.org_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'userid') {
                const updatedOptions = options.map(item => ({
                    value: item?.user_id,
                    label: item?.employee_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'contactPersonId') {
                const updatedOptions = options.map(item => ({
                    value: item?.contact_person_id,
                    label: `${item?.first_name} ${item?.last_name}`
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'statusId') {
                const updatedOptions = options.map(item => ({
                    value: item?.status_code,
                    label: item?.status_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'projCategoryId') {
                const updatedOptions = options.map(item => ({
                    value: item?.proj_category_id,
                    label: item?.proj_category_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'activityoutputTemplateId' || selectName == 'outputTemplateId') {
                const updatedOptions = options.map(item => ({
                    value: item?.template_id,
                    label: item?.template_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'categoryId' || selectName == 'subCategoryId') {
                const updatedOptions = options.map(item => ({
                    value: item?.category_id,
                    label: item?.category_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'activityIds') {
                const updatedOptions = options.map(item => ({
                    value: item?.activity_id,
                    label: item?.activity_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'activityTemplate' || selectName == 'eActivityTemplate') {
                const updatedOptions = options.map(item => ({
                    value: item?.activity_template_id,
                    label: item?.template_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'interactionMode') {
                const updatedOptions = options.map(item => ({
                    value: item?.slug,
                    label: item?.name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'billingEntity') {
                const updatedOptions = options.map(item => ({
                    value: item?.org_id,
                    label: item?.org_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'projectCategoryId') {
                const updatedOptions = options.map(item => ({
                    value: item?.proj_category_id,
                    label: item?.proj_category_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'billingEntityId') {
                const updatedOptions = options.map(item => ({
                    value: item?.billing_entity_id,
                    label: item?.org_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'clientId') {
                const updatedOptions = options.map(item => ({
                    value: item?.client_id,
                    label: item?.org_name
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'productCategory') {
                const updatedOptions = options.map(item => ({
                    value: item?.category_id,
                    label: item?.category_name,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'productSubCategory') {
                const updatedOptions = options.map(item => ({
                    value: item?.category_id,
                    label: item?.category_name,
                    pcatid: item?.parent_category_id,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'productId') {
                const updatedOptions = options.map(item => ({
                    value: item?.product_id,
                    label: item?.product_name,
                    pcatid: item?.category_id,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'currencyCode') {
                const updatedOptions = options.map(item => ({
                    value: item?.currency_code,
                    label: item?.currency_name,
                    symbol: item?.symbol,
                }));
                setOptionsList(updatedOptions);
            }
            else if (selectName == 'OrgType') {
                const updatedOptions = options.map(item => ({
                    value: item?.id,
                    label: item?.name,
                    code: item?.code,
                    stages: item?.stages,
                }));
                setOptionsList(updatedOptions);
            }
            else {
                const updatedOptions = options.map(item => ({
                    value: item?.id,
                    label: item?.name,
                }));
                setOptionsList(updatedOptions);
            }
        }
    }, [options]);

    const getSelectedValue = () => {
        if (isMulti) {
            if (!value || !Array.isArray(value)) {
                return [];
            }
            return optionsList.filter(option =>
                value.includes(option.value)
            );
        } else {
            return optionsList.find(option => option.value == value) || null;
        }
    };

    return (
        <Select
            name={selectName}
            value={getSelectedValue()}
            onChange={onChange}
            onBlur={onBlur}
            options={optionsList}
            placeholder={Firstop}
            isClearable
            isSearchable
            menuPortalTarget={document.body}
            styles={customStyles}
            isMulti={isMulti}
        />
    );
};


export default SelectFild;